import * as React from 'react';

const ConnectToAgent = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={14} fill="none">
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={0.613}
      d="M7.716 9.03c.217 1.268 4.337 1.188 4.337 3.79v.246H.743c0-3.1 4.098-2.64 4.336-4.036C3.985 7.874 3.4 5.77 3.77 4.21c.168-.705.53-1.307 1.132-1.68.396-.246.891-.387 1.496-.387.604 0 1.1.141 1.496.387.601.373.964.975 1.132 1.68.337 1.418-.237 3.781-1.31 4.819Z"
    />
    <path
      fill={fillColor}
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={0.175}
      d="M2.867 4.539v-.733c0-.793.346-1.514.904-2.036C4.327 1.25 5.01.927 5.85.927h1.005c.84 0 1.604.323 2.159.843.558.522.904 1.243.904 2.036l.033.733a.524.524 0 0 0-.069-.006.266.266 0 0 0-.255.18l-.041-.907c0-.699-.306-1.334-.798-1.795a2.825 2.825 0 0 0-1.933-.751H5.849c-.754 0-1.357.287-1.852.751A2.456 2.456 0 0 0 3.2 3.806v.935a.266.266 0 0 0-.263-.208.528.528 0 0 0-.069.006Zm3.92 3.335a.166.166 0 0 0-.02.33c.537.034 1.385-.06 2.062-.48.398-.248.793-.607.997-1.116a.266.266 0 0 1-.238-.268l.001-.082c-.133.56-.537.937-.936 1.184-.608.378-1.378.462-1.866.432Z"
    />
    <path
      stroke={fillColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={2.613}
      strokeWidth={0.613}
      d="M3.207 4.798a.266.266 0 0 0-.27-.261c-.88.013-.992 2.092.032 2.076a.266.266 0 0 0 .262-.27l-.024-1.545Zm6.406 0a.266.266 0 0 1 .27-.261c.88.013.993 2.092-.032 2.076a.266.266 0 0 1-.261-.27l.023-1.545Z"
    />
  </svg>
);
export default ConnectToAgent;
